import { render, staticRenderFns } from "./MessageItem.vue?vue&type=template&id=fc4896ac&scoped=true&"
import script from "./MessageItem.vue?vue&type=script&lang=ts&"
export * from "./MessageItem.vue?vue&type=script&lang=ts&"
import style0 from "./MessageItem.vue?vue&type=style&index=0&id=fc4896ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4896ac",
  null
  
)

export default component.exports